import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpRepository } from './base-http.repository';
import {
  CreateMatContactLogPayload,
  CreateMatContactLogResponse,
  MatContactLogPage
} from '../models/mat-contact-log.model';

/**
 * MAT contact log repository.
 * Backs the "Contactar utente" panel and the "Atividade" history block.
 * Routes target EzfyAPI.Api/Controllers/MatContactLogController.cs
 * (URL prefix /api/Patients/{accountId}/contacts).
 */
@Injectable({ providedIn: 'root' })
export class MatContactLogRepository extends BaseHttpRepository {
  createContact(accountId: string, payload: CreateMatContactLogPayload): Observable<CreateMatContactLogResponse> {
    return this.post<CreateMatContactLogResponse>(`/Patients/${accountId}/contacts`, payload);
  }

  listContacts(accountId: string, options?: { page?: number; pageSize?: number }): Observable<MatContactLogPage> {
    let params = new HttpParams();
    if (options?.page != null)     params = params.set('page', options.page);
    if (options?.pageSize != null) params = params.set('pageSize', options.pageSize);
    return this.get<MatContactLogPage>(`/Patients/${accountId}/contacts`, params);
  }
}
